export default "__VITE_ASSET__B83EIjfb__"